import React from "react";
import PropTypes from "prop-types";
import Icon from "../../Icon";
import { HandleTrack, HandleBadge } from "../styles/paneEdgeHandle.styles";

/**
 * Shared blue-line + chevron control used on resizable / collapsible panes
 * (SideNav rail, expanded SideNav panels, Ask TeamForm).
 */
const PaneEdgeHandle = ({
  edge = "end",
  as = "div",
  isSmallScreen = false,
  compactLayout = true,
  chevrons = "double",
  children,
  ...rest
}) => {
  const icons =
    children ??
    (isSmallScreen ? (
      <>
        <Icon
          icon={["far", "chevron-up"]}
          size="sm"
          fontSize="15px"
          color="white"
        />
        <Icon
          icon={["far", "chevron-down"]}
          size="sm"
          fontSize="15px"
          color="white"
        />
      </>
    ) : chevrons === "single" ? (
      <Icon
        icon={["far", edge === "start" ? "chevron-right" : "chevron-left"]}
        size="sm"
        fontSize="15px"
        color="white"
      />
    ) : (
      <>
        <Icon
          icon={["far", "chevron-left"]}
          size="sm"
          fontSize="15px"
          color="white"
        />
        <Icon
          icon={["far", "chevron-right"]}
          size="sm"
          fontSize="15px"
          color="white"
        />
      </>
    ));

  // aria-label is prohibited on a bare div; expose divs as a separator
  // (window-splitter pattern). Buttons etc. keep their native role.
  const roleProps =
    as === "div"
      ? {
          role: "separator",
          "aria-orientation": isSmallScreen ? "horizontal" : "vertical",
        }
      : {};

  return (
    <HandleTrack
      as={as}
      $edge={edge}
      $isSmallScreen={isSmallScreen}
      $compactLayout={compactLayout}
      {...roleProps}
      {...rest}
    >
      <HandleBadge
        className="pane-edge-handle-badge"
        $isSmallScreen={isSmallScreen}
        $compactLayout={compactLayout}
      >
        {icons}
      </HandleBadge>
    </HandleTrack>
  );
};

PaneEdgeHandle.propTypes = {
  edge: PropTypes.oneOf(["start", "end"]),
  as: PropTypes.elementType,
  isSmallScreen: PropTypes.bool,
  compactLayout: PropTypes.bool,
  chevrons: PropTypes.oneOf(["single", "double"]),
  children: PropTypes.node,
};

export default PaneEdgeHandle;
